import ApiInstance from "./ApiInstance";

export interface Consent {
  terms: boolean;
  medicalData: boolean;
  version?: string;
}

export interface MatchPayload {
  age: number;
  topic: string;
  subtopic?: string;
  region: string;
  freeText?: string;
  fundCode?: string;
  wellbeingScore?: number;
  consent: Consent;
  referralSource?: string;
}

export interface RankedPsychologist {
  id: string;
  displayName: string;
  photoUrl?: string;
  bio?: string;
  languages: string[];
  specializations: string[];
  rateCents: number;
  gender?: string;
  profession?: string;
  eligibleFundCodes?: string[];
}

export interface Reimbursement {
  fundCode: string;
  fundName: string;
  perSessionCents: number;
  youPayCents: number;
  maxSessionsPerYear: number;
  autoSettled: boolean;
  conditions?: string;
  infoUrl?: string;
  notEligible?: boolean;
}

export interface MatchResults {
  recommendation: "coaching" | "therapy" | "self_help";
  referenceRateCents: number;
  reimbursement: Reimbursement | null;
  psychologists: RankedPsychologist[];
}

class MatchApi {
  async create(payload: MatchPayload): Promise<{ matchProfileId: string; recommendation: string }> {
    const { data } = await ApiInstance.getApi().post("/match", payload);
    return data;
  }

  async results(matchProfileId: string, language?: string): Promise<MatchResults> {
    const { data } = await ApiInstance.getApi().get(`/match/${matchProfileId}/results`, {
      params: language ? { language } : undefined,
    });
    return data;
  }
}

const matchApi = new MatchApi();
export default matchApi;
